/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { HTTPValidationError } from "./HTTPValidationError.ts";
import type { PeriodTpvStats } from "./PeriodTpvStats.ts";
import type { TpvPeriod } from "./TpvPeriod.ts";

export const getTpvStatsV1StatsTpvGetQueryParamsNetworkEnum = {
	REGTEST: "REGTEST",
	MAINNET: "MAINNET",
} as const;

export type GetTpvStatsV1StatsTpvGetQueryParamsNetworkEnum =
	(typeof getTpvStatsV1StatsTpvGetQueryParamsNetworkEnum)[keyof typeof getTpvStatsV1StatsTpvGetQueryParamsNetworkEnum];

export type GetTpvStatsV1StatsTpvGetQueryParams = {
	/**
	 * @type string
	 */
	network: GetTpvStatsV1StatsTpvGetQueryParamsNetworkEnum;
	/**
	 * @description Specify the period (24h, 7d, 30d, all)
	 * @type string | undefined
	 */
	period?: TpvPeriod;
};

/**
 * @description Successful Response
 */
export type GetTpvStatsV1StatsTpvGet200 = PeriodTpvStats;

/**
 * @description Validation Error
 */
export type GetTpvStatsV1StatsTpvGet422 = HTTPValidationError;

export type GetTpvStatsV1StatsTpvGetQueryResponse = GetTpvStatsV1StatsTpvGet200;

export type GetTpvStatsV1StatsTpvGetQuery = {
	Response: GetTpvStatsV1StatsTpvGet200;
	QueryParams: GetTpvStatsV1StatsTpvGetQueryParams;
	Errors: GetTpvStatsV1StatsTpvGet422;
};
